import { render, staticRenderFns } from "./StaticsReportPO.vue?vue&type=template&id=08dcdfc5&scoped=true"
import script from "./StaticsReportPO.vue?vue&type=script&lang=js"
export * from "./StaticsReportPO.vue?vue&type=script&lang=js"
import style0 from "./StaticsReportPO.vue?vue&type=style&index=0&id=08dcdfc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dcdfc5",
  null
  
)

export default component.exports